import { Star } from "lucide-react";
import { useState } from "react";
import { isFavorite, toggleFavorite } from "@/lib/store";
import { toast } from "sonner";

export default function FavoriteButton({ creds, kind, item, variant = "overlay", className = "" }) {
  const [fav, setFav] = useState(() => isFavorite(creds, kind, item));

  const onClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const now = toggleFavorite(creds, kind, item);
    setFav(now);
    toast.success(now ? "Added to My List" : "Removed from My List");
  };

  if (variant === "button") {
    return (
      <button
        data-testid="favorite-toggle"
        onClick={onClick}
        className={`inline-flex items-center gap-2 h-12 px-6 rounded-md border text-base font-semibold transition-all active:scale-95 ${
          fav
            ? "border-[#E5A93C]/60 bg-[#E5A93C]/10 text-[#E5A93C]"
            : "border-white/15 bg-white/5 text-white hover:bg-white/10"
        } ${className}`}
      >
        <Star className={`h-5 w-5 ${fav ? "fill-[#E5A93C]" : ""}`} />
        {fav ? "In My List" : "My List"}
      </button>
    );
  }

  return (
    <button
      data-testid="favorite-toggle"
      onClick={onClick}
      aria-label="Toggle favourite"
      className={`absolute top-2 left-2 z-10 h-8 w-8 rounded-full flex items-center justify-center backdrop-blur bg-black/50 border border-white/10 transition-all hover:scale-110 ${className}`}
    >
      <Star className={`h-4 w-4 ${fav ? "fill-[#E5A93C] text-[#E5A93C]" : "text-white"}`} />
    </button>
  );
}
